import {
  DatePicker,
  DatePickerProps,
  Icon,
  InputAdornment,
  InputControl,
  InputProps,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { CalendarIcon } from '@tonic-one/react-icons';
import { useState } from 'react';
import dayjs from 'dayjs';
import { format } from 'date-fns';
import { de, enUS, es, it, ja, pt } from 'date-fns/locale';
import i18next from 'i18next';

const CustomDateInput = ({
  inputFormat = 'yyyy-MM-dd',
  defaultValue,
  minDate,
  maxDate,
  onChange,
  placement = 'top',
  withEditPermission = true,
  ...rest
}: {
  inputFormat?: string;
  placement?: DatePickerProps['placement'];
  minDate?: Date;
  maxDate?: Date;
  defaultValue: Date | string;
  onChange: (date: Date) => void;
  withEditPermission?: boolean;
  [key: string]: any;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const [value, setValue] = useState<Date | string>(defaultValue);
  const lang = { en: enUS, ja, it, de, pt, es }[i18next.language] || enUS;

  const handleChange = (value: Date) => {
    setValue(value);
    onChange(value);
  };

  const renderCustomInput = ({
    error,
    inputProps,
  }: {
    error?: boolean;
    inputProps?: InputProps;
  }) => (
    <InputControl
      {...(withEditPermission ? inputProps : {})}
      readOnly={withEditPermission}
      disabled={!withEditPermission}
      value={dayjs(inputProps?.value as string).format('YYYY-MM-DD')}
      error={!!inputProps?.value && !!error}
      placeholder={inputFormat}
      borderTopRightRadius={0}
      borderBottomRightRadius={0}
      width={140}
      startAdornment={
        <InputAdornment color={colorStyle.color.secondary}>
          <Icon as={CalendarIcon} />
        </InputAdornment>
      }
    />
  );

  return (
    <DatePicker
      formatDate={(date: Date | number, inputFormat: string) => {
        return format(date, inputFormat, { locale: lang });
      }}
      placement={placement}
      value={value}
      onChange={handleChange}
      inputFormat={inputFormat}
      minDate={minDate}
      maxDate={maxDate}
      renderInput={renderCustomInput}
      {...rest}
    />
  );
};

export default CustomDateInput;
